import React from "react";
import Frame76 from "../subcomponents/Course";
import Course from "../subcomponents/Frame76";

const Frame3 = () => {
      return(
            <div className="course-parent">
                  <Frame76 />
                  <Course />
            </div>
      );
};

export default Frame3;